define('../app/fukit/view/block/note.body.view',['require','exports','module','../../behavior/bind.and.format.option.values.behavior','redactor/redactor','uikit/uikit'],function(require, exports, module) {
  //prettier-ignore
  var BindAndFormatOptionValuesBehavior = require('../../behavior/bind.and.format.option.values.behavior'),
      Redactor                          = require('redactor/redactor'),
      UIKit                             = require('uikit/uikit');


  var NoteBodyView = UIKit.ItemView.extend({
    template: function() {
      return '<ui name="redactorView" />'
    },

    className: 'note detail container',

    internalViewBindings: {
      redactorView: {
        model: 'model'
      }
    },

    internalViewOptions: {
      redactorView: function() {
        return {
          type: Redactor.RedactorView,
          className: 'redactor air',
          air: true,
          buttons: ['link'],
          placeholder: 'Enter note message here...',
          bindings: {
            value: 'noteBody'
          },
          behaviors: {
            BindAndFormatOptionValuesBehavior: {
              optionValues: {
                disabled: {
                  formatWithoutResource: true,
                  formatter: function(model) {
                    return !model;
                  }
                }
              },
              behaviorClass: BindAndFormatOptionValuesBehavior
            }
          }
        }
      }
    }
  });

  module.exports = NoteBodyView;
});

